import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        
        {/* 1. LOGO (Izquierda) */}
        <div className="footer-col-logo">
            <img src="/resources/logoVector.png" alt="Logo Comuna" className="footer-logo" />
            <h3>Comuna de<br/>Santo Domingo</h3>
        </div>

        {/* 2. REDES (Centro) */}
        <div className="footer-col-social">
            <span className="social-label">Seguinos en redes</span>
            <div className="social-icons-container">
                <a href="https://www.facebook.com/profile.php?id=100069205269877" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="Facebook">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.15 5.96C15.21 5.96 16.12 6.04 16.39 6.08V8.7H14.86C13.65 8.7 13.41 9.27 13.41 10.13V12.06H16.32L15.85 14.96H13.41V21.96C18.19 21.21 21.85 17.06 21.85 12.06C21.85 6.53 17.35 2.04 12 2.04Z"/>
                    </svg>
                </a>
                <a href="https://www.instagram.com/comunasd1903/" target="_blank" rel="noreferrer" className="footer-social-link" aria-label="Instagram">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M7.8 2H16.2C19.4 2 22 4.6 22 7.8V16.2C22 19.4 19.4 22 16.2 22H7.8C4.6 22 2 19.4 2 16.2V7.8C2 4.6 4.6 2 7.8 2ZM7.6 4C5.6 4 4 5.6 4 7.6V16.4C4 18.4 5.6 20 7.6 20H16.4C18.4 20 20 18.4 20 16.4V7.6C20 5.6 18.4 4 16.4 4H7.6ZM17.25 5.5C17.5261 5.5 17.75 5.72386 17.75 6C17.75 6.27614 17.5261 6.5 17.25 6.5C16.9739 6.5 16.75 6.27614 16.75 6C16.75 5.72386 16.9739 5.5 17.25 5.5ZM12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7ZM12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9Z"/>
                    </svg>
                </a>
            </div>
        </div>

        {/* 3. CONTACTO (Derecha) */}
        <div className="footer-col-contact">
            <p><strong>Dirección:</strong> Avenida Las Americas 357</p>
            <p><strong>Tel:</strong> (3497) 401754</p>
            <p><strong>Email:</strong> presidenciacomunasd@gmail.com</p>
        </div>

      </div>

      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} Comuna de Santo Domingo. Gestión que avanza.</p>
      </div>
    </footer>
  );
};

export default Footer;